<template>
  <div class="name">
    <p
      :class="{
        stattrak: item?.is_stattrak,
        souvenir: item?.is_souvenir,
        gray: !item?.is_stattrak && !item?.is_souvenir,
      }"
      class="name_model"
    >
      {{ getCollection(item.market_hash_name) }}
    </p>
    <p
      v-if="item"
      class="name_main ell"
    >
      {{ getItemNameOnly(item.localed_name) }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import type { ItemsPriceDiffs } from '~/graphql/generated/schema-types';
import { getCollection } from '~/utils/name-utils';

defineProps<{
  item: ItemsPriceDiffs
}>();
</script>

<style lang="scss" scoped>
.name {
  .gray {
    color: var(--gray);
  }

  &_model {
    font-weight: 300;
    font-size: 1.2rem;
    margin-bottom: 0.4rem;
  }

  &_main {
    font-weight: 500;
    font-size: 1.4rem;
    color: var(--accent-on-accent-secondary);
    min-height: 3.6rem;
  }
}
</style>
